import React, { useState, useEffect } from 'react';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import CSSLoader from '../../../shared/cssLoader';
import styles from './coverletter.module.scss';
import { getPresignedUrlToViewCandidateCoverLetter } from '../../../../services/util/hiringpipeline/candidates';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const CandidateCoverLetterView = (props) => {
    const [defaultScale, setDefaultScale] = useState(1.2);
    const [defaultScalePrecentage, setScalePrecentage] = useState(100);
    let [numPages, setNumPages] = useState(null);
    let [pageNumber, setPageNumber] = useState(1);
    let [candidateValues, setCandidateValues] = useState(props.candidateValues);
    let [isDownloadCoverLetterPending, setIsDownloadCoverLetterPending] = useState(false);
    const [coverLetterObject, setCoverLeterObject] = useState({ url: null })

    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };

    const zoomin = () => {
        if (defaultScale < 2) {
            setDefaultScale(defaultScale + 0.2);
            setCvViewprecentage((defaultScale + 0.2));
        }

    }
    const zoomout = () => {
        if (defaultScale > 0.8) {
            setDefaultScale(defaultScale - 0.2);
            setCvViewprecentage((defaultScale - 0.2));
        }
    }

    const setCvViewprecentage = (value) => {
        //check scale value and change precentage value according to scale value
        setScalePrecentage(value === 1.5999999999999999 ? 150 : value === 1.4 ? 125 : value === 1.2 ? 100 : value === 1.0 ? 75 : value === 0.8 ? 50 : 0)
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }

    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }
    //load user values
    const getCoverLetterDetails = async () => {
        // setLoading(true)
        if (props.coverLetterURL) {
            setCoverLeterObject({ url: props.coverLetterURL })
        }

    }


    const downloadCVClick = async () => {
        setIsDownloadCoverLetterPending(true);
        let respond = await getPresignedUrlToViewCandidateCoverLetter(props.candidateID);
        if (respond.success === true) {
            if (respond.data.presigned_url) {
                setIsDownloadCoverLetterPending(false);
                window.open(respond.data.presigned_url)
            } else {
                setIsDownloadCoverLetterPending(false);
            }
        } else {
            setIsDownloadCoverLetterPending(false);
        }
    }

    useEffect(() => {
        getCoverLetterDetails();
    }, []);

    return (
        <div>

            <div className="mt-3">
                <Card className={styles.cvViewCard}>
                    <Card.Header className={styles.cardHeader}>
                        <div className={styles.headerDetails}>
                            <p className={styles.accordianHeaderTopic}>Cover Letter of&nbsp;&nbsp;{candidateValues.candidate_first_name && candidateValues.candidate_last_name ? candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name : candidateValues.candidate_name ? candidateValues.candidate_name : null}</p>
                            <div className={styles.pdfcomponentActions}>
                                <div className={styles.cvZoomcomponent}>
                                    <div className={styles.cvdownloadIcon}>
                                        <Button className={styles.zoomBtn} onClick={() => downloadCVClick()} disabled={defaultScalePrecentage === 25 ? true : false}>
                                            {isDownloadCoverLetterPending ? <i class="fas fa-spinner fa-spin"></i> : <i class="fas fa-cloud-download-alt"></i>}
                                        </Button>

                                    </div>
                                    <Button className={styles.zoomBtn} onClick={() => zoomout()} disabled={defaultScalePrecentage === 25 ? true : false}>
                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M15.75 15.7498L12.4875 12.4873" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M6 8.25H10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Button>
                                    <span className="ml-2 mr-2">{defaultScalePrecentage}%</span>
                                    <Button className={styles.zoomBtn} onClick={() => zoomin()} disabled={defaultScalePrecentage === 150 ? true : false}>
                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M15.75 15.7498L12.4875 12.4873" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M8.25 6V10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M6 8.25H10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Button>
                                </div>
                                <div className={styles.pageChangerComponent}>
                                    <Button className={styles.pageMoveBtn} disabled={pageNumber === 1 ? true : false} onClick={() => prevPage()}>
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 6L9 12L15 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Button>
                                    <span className="ml-2 mr-2"><span>{pageNumber}/{numPages}</span></span>
                                    <Button className={styles.pageMoveBtn} disabled={pageNumber === numPages ? true : false} onClick={() => nextPage()}>
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body className={styles.cvViewBody}>
                        <Document
                            file={coverLetterObject}
                            onLoadSuccess={onDocumentLoadSuccess}
                            options={options}
                            loading={<div>
                                <Col sm={{ span: 4, offset: 4 }}>
                                    <CSSLoader />
                                </Col>
                            </div>}
                        >

                            <Page pageNumber={pageNumber} scale={defaultScale} />
                        </Document>
                    </Card.Body>
                </Card>
            </div>
        </div>
    )
}

export default CandidateCoverLetterView